import { render, staticRenderFns } from "./_MODAL_TAMBAH.vue?vue&type=template&id=49f9d082&"
import script from "./_MODAL_TAMBAH.vue?vue&type=script&lang=js&"
export * from "./_MODAL_TAMBAH.vue?vue&type=script&lang=js&"
import style0 from "./_MODAL_TAMBAH.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QCardActions,QBtn})
